import { Button } from "@chakra-ui/react"
import Spinner from "../../../common/Spinner"
import { colors } from "../../../../utilities/colors"

export default function FilterButtons({handleResetFilter, handleSubmit, resultsCount, resultsFetching}) {
  return(
    <>
      <Button
        variant="outline"
        borderColor={colors.fpxRed}
        color="white"
        borderWidth={'2px'}
        borderRadius='full'
        px={4}
        onClick={handleResetFilter}
        className="mt-2 mr-2"
        _hover={{ opacity: 0.75, cursor: "pointer" }}
      >
        Clear Filters
      </Button>
      <Button
        variant="outline"
        borderColor={colors.green}
        borderWidth={'2px'}
        color="white"
        borderRadius='full'
        onClick={handleSubmit}
        className="mt-2"
        _hover={{ opacity: 0.75, cursor: "pointer" }}
        minW={'150px'}
      >
        {resultsFetching ?
          <Spinner color={colors.green} height={'25px'}/>
          :
          `Show ${resultsCount} ${resultsCount == 1 ? 'Result' : 'Results'}`
        }
      </Button>
    </>
  )
}